export default __webpack_public_path__ + "static/media/photo8.7de9cf98.jpg";